import envConfig from '@/config/env';
import axios, { AxiosError, AxiosInstance, AxiosResponse } from 'axios';
import { IRequestConfig, IResponse } from './request.interface';
import { chainIdMapApiFix } from '@/config/chainConfig';
export default class RequestInstance {
  private businessInstance: AxiosInstance;
  private referralInstance: AxiosInstance;
  private smartMoneyInstance: AxiosInstance;

  constructor() {
    this.businessInstance = axios.create({
      baseURL: envConfig.VITE_API_BUSINESS_URL,
    });
    this.referralInstance = axios.create({
      baseURL: envConfig.VITE_API_BASE_URL,
    });
    this.smartMoneyInstance = axios.create({
      baseURL: envConfig.VITE_API_SMART_URL,
    });
    this.businessInit();
    this.referralInit();
    this.smartMoneyInit();
  }

  protected businessInit() {
    this.businessInstance.interceptors.request.use((request) => {
      const chain = localStorage.getItem('chain') || 'sol';
      const apiFix = chainIdMapApiFix[chain];
      request.url = `${apiFix}${request.url}`;
      const walletAddress = localStorage.getItem('currentWalletAddress');
      if (walletAddress) {
        request.headers.Authorization = `Bearer ${localStorage.getItem(walletAddress.toLocaleLowerCase())}`;
      }
      return request;
    }),
      (error: any) => error;

    this.businessInstance.interceptors.response.use(
      (response: AxiosResponse) => {
        return Promise.resolve(response.data);
      },
      (error: AxiosError) => {
        return Promise.reject(error.response?.data || error.code);
      },
    );
  }

  protected referralInit() {
    this.referralInstance.interceptors.request.use((request) => {
      const chain = localStorage.getItem('chain') || 'sol';
      const apiFix = chainIdMapApiFix[chain];
      request.url = `${apiFix}${request.url}`;
      const walletAddress = localStorage.getItem('currentWalletAddress');
      if (walletAddress) {
        request.headers.Authorization = `Bearer ${localStorage.getItem(walletAddress.toLocaleLowerCase())}`;
      }
      return request;
    }),
      (error: any) => error;

    this.referralInstance.interceptors.response.use(
      (response: AxiosResponse) => {
        return Promise.resolve(response.data);
      },
      (error: AxiosError) => {
        return Promise.reject(error.response?.data || error.code);
      },
    );
  }

  protected smartMoneyInit() {
    this.smartMoneyInstance.interceptors.request.use((request) => {
      return request;
    }),
      (error: any) => error;
    this.smartMoneyInstance.interceptors.response.use(
      (response: AxiosResponse) => {
        return Promise.resolve(response.data);
      },
      (error: AxiosError) => {
        return Promise.reject(error.response?.data || error.code);
      },
    );
  }

  async businessRequest<T>(config: IRequestConfig): Promise<IResponse<T>> {
    try {
      return await this.businessInstance.request(config);
    } catch (err: any) {
      return Promise.reject<IResponse<T>>({
        code: err.statusCode,
        message: err.message,
        data: err.errorCode,
      });
    }
  }

  async smartMoneyRequest<T>(config: IRequestConfig): Promise<T> {
    try {
      return await this.smartMoneyInstance
        .request(config)
        .then((res) => res)
        .catch((err) => err);
    } catch (err: any) {
      return Promise.reject<T>({
        code: err.statusCode,
        message: err.message,
        data: err.errorCode,
      });
    }
  }

  async referralRequest(config: IRequestConfig) {
    return await this.referralInstance
      .request(config)
      .then((res) => res)
      .catch((err) => err);
  }
}
